import { AccessInfoType } from './getAccessModalInfo';

export enum RoleCheckActionType {
  TRADE = 'TRADE',
  BUY = 'BUY',
  SELL = 'SELL',
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
  SWAP = 'SWAP',
  STAKE = 'STAKE',
}

export interface UserAccessResult {
  allowed: boolean;
  accessInfoType?: AccessInfoType;
}
